<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/info-pool?id=4">信息交流</router-link></li>
                <li><router-link :to="`/layout/share-info?id=2&page=${parentPage}`">共享信息</router-link></li>
                <li class="currentNode"><a>{{ officeName }}</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>信息交流</a></li>
                    <li><router-link to="/layout/info-pool?id=4" :class="{'active': id === '4'}">每日信息</router-link></li>
                    <li><router-link to="/layout/share-info?id=2" :class="{'active': id === '2'}">共享信息</router-link></li>
                    <li><router-link to="/layout/info-pool?id=3" :class="{'active': id === '3'}">专报信息</router-link></li>
                    <li><router-link to="/layout/info-pool?id=1" :class="{'active': id === '1'}">智库信息</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>{{ officeName }}</h3>
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        :show-header="false">
                        <el-table-column
                            label="点"
                            width="10">
                            <template slot-scope="">
                                <span class="dot"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="内容">
                            <template slot-scope="scope">
                                <a class="table_a" @click="goDetail(scope.row)">
                                    <p class="ellipsis_one">{{ scope.row.Title }}</p>
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="UpdateTime"
                            label="日期"
                            width="120">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getGongxiangZhujingban
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            tableData:[],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            id: '', //  所有0，智库信息1，共享信息2，专报信息3，一般信息4
            title: '',
            officeId: '', // 驻京办Id
            officeName: '',
            page: 1,
            parentPage: 1,
        }
    },
    created() {
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        if (this.$route.query.parentPage) {
            this.parentPage = this.$route.query.parentPage;
        }
        this.id = this.$route.query.id;
        this.officeId = this.$route.query.officeId;
        this.officeName = this.$route.query.officeName;
        // this.traverseTitle();
        this.getGongxiangZhujingban();
    },
    methods: {
        traverseTitle() {
            console.log(this.id);
            if (this.id === '1'){
                this.title = "智库信息";
            } else if (this.id === '2') {
                this.title = "共享信息";
            }else if (this.id === '3') {
                this.title = "专报信息";
            } else {
                this.title = "每日信息";
            }
        },
        getGongxiangZhujingban() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                id: this.officeId
            };
            getGongxiangZhujingban(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.tableData = [...res.Data];
                    this.total = res.Count;
                } else {
                    this.tableData = [];
                    this.$message.error("驻京办共享信息求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getGongxiangZhujingban();
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/share-info-item-detail',
                query: {
                    id: data.Id,
                    type: this.id,
                    page: this.currentPage,
                    parentPage: this.parentPage,
                    officeName: this.officeName,
                    officeId: this.officeId
                }
            });
            window.open(newUrl.href, '_blank');
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                // this.id = to.query.id + "";
                // this.getYaowen()
                // this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        }
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px 42px;
}
.page-content h3{
    text-align:left;
}
.trends-list{
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.trends-item {
    width: 456px;
    margin-right: 20px;
    cursor: pointer;
}
.trends-list .trends-item:nth-child(2n) {
    margin-right:0;
}
.trends-item img {
    width: 456px;
    height: 280px;
}
.trends-item-btm{
    padding-top: 10px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.trends-date {
    width: 90px;
    height: 70px;
    background: #F3F3F3;
    display: flex;
    justify-content:center;
    align-items: center;
}
.trends-date .day{
    font-family: 思源黑体 CN;
    font-size: 30.86px;
    line-height: 37.03px;
    text-align: left;

}
.trends-date .bias{
    font-size: 28px;
    font-weight: 200;

}
.trends-date .month{
    font-family: Source Sans Pro;
    font-size: 10px;
    font-weight: 400;
    line-height: 12.57px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.trends-date .month i{
    font-style: normal;
}
.trends-news {
    width: 349px;
    cursor:pointer;
}
.trends-news h4{
    font-size: 18px;
    color: #262626;
    margin-bottom: 6px;
}
.trends-news p{
    font-size: 14px;
    color: #6A6A6A;
}
.trends-news:hover h4,
.trends-news:hover p{
    color: #116EBA;
}
.ellipsis_one{
    cursor: pointer;
}
</style>